import React from 'react';
import { Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const TermosUso: React.FC = () => {
  return (
    <LegalPageLayout
      title="Termos de Uso"
      updatedAt="28 de setembro de 2026"
      seoTitle="Termos de Uso | MedPrime Benefícios"
      seoDescription="Termos de Uso da MedPrime Benefícios."
      canonicalPath="/termos"
    >
      <Typography component="h2">1. Sobre a MedPrime Benefícios</Typography>
      <Typography component="p">
        <strong>MedPrime Benefícios</strong> é a marca comercial utilizada para apresentação e
        atendimento comercial relacionados a planos de saúde para médicos, clínicas e
        empresas/PMEs. A marca é operada por{' '}
        <strong>VITOR DE OLIVEIRA JUNIOR INFORMATICA</strong>, inscrita no CNPJ sob o nº
        32.256.713/0001-07, com sede na Avenida do Taboão, nº 3207, Bloco 2, Apto 1007, Bairro
        Taboão, São Bernardo do Campo — SP, CEP 09656-000.
      </Typography>
      <Typography component="p">
        Ao utilizar este site, o visitante concorda com os termos aqui descritos.
      </Typography>

      <Typography component="h2">2. Serviços apresentados</Typography>
      <Typography component="p">
        Este site apresenta informações sobre planos de saúde e possibilita o contato comercial
        para avaliação de opções disponíveis para médicos, clínicas e empresas/PMEs. A
        contratação efetiva de qualquer plano está sujeita às condições do produto, da operadora,
        da administradora e/ou da corretora/intermediadora responsável, bem como à proposta e à
        documentação aplicável em cada caso.
      </Typography>
      <Typography component="p">
        As informações apresentadas neste site têm caráter informativo e não constituem promessa
        de aprovação, preço, cobertura ou contratação, que dependem sempre da análise específica
        de cada solicitação.
      </Typography>

      <Typography component="h2">3. A MedPrime Benefícios não é uma operadora de plano de saúde</Typography>
      <Typography component="p">
        A MedPrime Benefícios atua na apresentação e intermediação de contato comercial e não é
        uma operadora de plano de saúde, não sendo responsável pela cobertura médica, pela rede
        credenciada ou pelas obrigações assistenciais do plano contratado, que são de
        responsabilidade da respectiva operadora.
      </Typography>

      <Typography component="h2">4. Leads e contato comercial</Typography>
      <Typography component="p">
        O preenchimento do formulário disponível neste site ou o contato realizado pelo WhatsApp
        não representam, por si só, a contratação de qualquer plano de saúde. Esses canais têm
        finalidade comercial e de atendimento, permitindo que a equipe responsável entre em
        contato com o interessado para apresentar opções e, quando aplicável, elaborar uma
        proposta. A efetiva contratação dependerá das condições aplicáveis ao produto escolhido e
        da documentação exigida pela operadora ou administradora correspondente.
      </Typography>

      <Typography component="h2">5. Canal de WhatsApp</Typography>
      <Typography component="p">
        O WhatsApp é disponibilizado neste site apenas como canal de comunicação e atendimento.
        Seu uso está sujeito também aos termos do próprio aplicativo. A MedPrime Benefícios não
        afirma qualquer parceria comercial, certificação ou aprovação da Meta.
      </Typography>

      <Typography component="h2">6. Uso do site</Typography>
      <Typography component="p">
        O visitante compromete-se a utilizar este site de forma lícita, fornecendo informações
        verdadeiras nos formulários de contato, e a não utilizar o site para finalidades
        diferentes daquelas para as quais foi disponibilizado.
      </Typography>

      <Typography component="h2">7. Propriedade intelectual</Typography>
      <Typography component="p">
        A marca MedPrime Benefícios, os textos, imagens e demais elementos deste site são
        protegidos e não podem ser reproduzidos, copiados ou utilizados sem autorização prévia.
      </Typography>

      <Typography component="h2">8. Tratamento de dados pessoais</Typography>
      <Typography component="p">
        O tratamento de dados pessoais realizado por meio deste site é descrito em detalhes na
        nossa{' '}
        <Link component={RouterLink} to="/privacidade" sx={{ fontWeight: 600 }}>
          Política de Privacidade
        </Link>
        .
      </Typography>

      <Typography component="h2">9. Alterações destes Termos</Typography>
      <Typography component="p">
        Estes Termos de Uso podem ser atualizados periodicamente. A data da última atualização
        está indicada no topo desta página.
      </Typography>

      <Typography component="h2">10. Contato</Typography>
      <Typography component="p">
        Dúvidas sobre estes Termos podem ser encaminhadas para{' '}
        <strong>contato@medprimebeneficios.com.br</strong>.
      </Typography>
    </LegalPageLayout>
  );
};

export default TermosUso;
